import { Box, Typography } from '@mui/material'
import Link from 'next/link'

export const ReferralBlock = () => {
	return (
		<Box>
			<Box
				className='pd-30 bg-color-block border-radius-main mt-15'
				sx={{ width: '100%', backgroundColor: '#8280FF !important' }}
			>
				<Typography
					className='title-block'
					sx={{ fontWeight: 600, marginBottom: '20px', color: 'white !important' }}
					fontSize='16px'
				>
					Реферальная программа
				</Typography>
				<Typography
					sx={{ fontSize: '15px', marginTop: '10px', fontWeight: 500, color: '#ffffff !important' }}
				>
					Получай токены: 20% за оплаты твоих рефералов!
				</Typography>
				<Link href={'/account?scope=referral'}>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='center'
						sx={{
							marginTop: '15px',
							backgroundColor: '#ffffff26',
							borderRadius: '10px',
							padding: '10px 15px',
							width: '100%',
						}}
					>
						<Typography sx={{ marginLeft: '10px', color: '#ffffff', fontSize: 16, fontWeight: 500 }}>
							Пригласить друга
						</Typography>
					</Box>
				</Link>
			</Box>
		</Box>
	)
}
